<template>
  <main class="m-ignition">
    <transition name="nav" appear>
      <header class="m-ignition-header" v-show="isShowHeader">
        <div class="m-ignition-header__logo"/>
        <button @click="onClickPlayFree" class="m-ignition-header__btn play-free-btn">Play Free</button>
      </header>
    </transition>
    <section v-observe-visibility="observeVisibilityNavSettings" class="m-ignition-section section-first">
      <h2 class="section-first__title">
        Enjoy MapleStory's Ignition update continued with DJ Selena's Amazing Ignition Finale, holiday decorations for
        your Home, and the upcoming arrival of Extreme Boss Difficulty and the mysterious Odium!
      </h2>
      <button @click="onClickPlayFree" class="section-first__btn play-free-btn">Play Free</button>
      <div class="section-first__patches">
        <a @click="onClickGoToPatch237" href="https://maplestory.nexon.net/news/77917" target="_blank"
           class="section-first__patch">Go to V.237 patch notes!</a>
        <a @click="onClickGoToPatch238" href="https://maplestory.nexon.net/news/78591" target="_blank"
           class="section-first__patch">Go to V.238 patch notes!</a>
      </div>
    </section>
    <!--    <section v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Ignition warm-up event"-->
    <!--             class="m-ignition-section section-second">-->
    <!--      <article class="m-ignition-section__article">-->
    <!--        <header class="m-ignition-section__header section-second__header">-->
    <!--          <h3 class="m-ignition-section__title">Arrives on December 14</h3>-->
    <!--        </header>-->
    <!--        <main class="section-second__main">-->
    <!--          <p class="section-second__main-text m-ignition-section__text">-->
    <!--            Get prepared for the Ignition update with a special Warm-Up Event, running now in MapleStory!-->
    <!--            Hunt down monsters near your level each day as the Ignition update approaches to earn special rewards,-->
    <!--            including Petite Luna pets, special outfits, piles of Maple Points, and more! Learn more in the-->
    <!--            <span class="section-second__main-post">-->
    <!--                  <a @click="clickTracking('Ignition warm-up event')" target="_blank"-->
    <!--                     href="https://maplestory.nexon.net/news/77597/ignition-warm-up-event">-->
    <!--                    Ignition Warm-Up Event post-->
    <!--                  </a>-->
    <!--                </span>!-->
    <!--          </p>-->
    <!--          <div class="section-second__main-rewards"/>-->
    <!--        </main>-->
    <!--      </article>-->
    <!--    </section>-->
    <section v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Available now - top"
             class="m-ignition-section section-second">
      <article class="m-ignition-section__article">
        <header class="m-ignition-section__header section-second__header">
          <h3 class="m-ignition-section__title">Available now!</h3>
        </header>
        <main class="section-second__main">
          <div class="section-second__main-screen" v-for="screenshot in screenshots" :key="screenshot.name">
            <img class="section-second__main-img" :alt="screenshot.name"
                 :src="require(`@/assets/images/microsites/ignition/screenshots/${isMobile ? screenshot.imageMob : screenshot.image}`)"/>
            <h5 class="section-second__main-title">{{ screenshot.title }}</h5>
            <p class="section-second__main-text">{{ screenshot.text }}</p>
          </div>
        </main>
      </article>
    </section>
    <section v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Available now - second"
             class="m-ignition-section places">
      <article class="m-ignition-section__article">
        <header class="m-ignition-section__header section-second__header">
          <h3 class="m-ignition-section__title">Available now!</h3>
        </header>
        <main class="section-second__main">
          <div class="section-second__main-block" v-for="place in places" :key="place.name">
            <img class="section-second__main-img"
                 :src="require(`@/assets/images/microsites/ignition/places/${isMobile ? place.imageMob : place.image}`)"
                 :alt="place.name"/>
            <h5 class="section-second__main-title">{{ place.title }}</h5>
            <p class="section-second__main-text">{{ place.text }}</p>
          </div>
        </main>
      </article>
    </section>
    <section v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Cygnys Knight revamp"
             class="m-ignition-section section-third">
      <article class="m-ignition-section__article">
        <header class="m-ignition-section__header section-third__header">
          <h3 class="m-ignition-section__title ">Cygnus Knights Revamp</h3>
        </header>
        <main class="section-third__main">
          <p class="section-third__main-text m-ignition-section__text">
            The Cygnus Knights are some of the oldest classes in MapleStory, an order of legendary warriors that battled
            the Black Mage in the days of old, and they have returned once again to finish their noble fight. There's no
            better time to create a Cygnus Knight of your very own and experience their epic tale as these classes are
            getting revamped with the Ignition update!
          </p>
          <p class="section-third__main-text m-ignition-section__text">
            All six Cygnus Knight classes are getting upgraded with new skills, improved animations, and additional
            story segments to flesh out their adventures in Maple World further! As with the Explorer classes during the
            Destiny update, we've been careful to avoid confusing veteran Cygnus Knight Maplers or changing what they
            love about the classes. Check out the new and improved Cygnus Knights below!
          </p>
          <p class="section-third__main-text m-ignition-section__text-arr">- Available Now -</p>
        </main>
      </article>
      <footer class="section-third-table">
        <h4 class="section-third-table__title">Choose your Cygnus Knight!</h4>
        <ul class="section-third-table__wrapper">
          <li class="section-third-table__elem" v-for="(character, index) in characters"
              @click="openModal(index, character)" :key="index">
            <footer class="section-third-table__elem-footer">
              <h5 class="section-third-table__elem-name">{{ character.name }}</h5>
            </footer>
          </li>
        </ul>
      </footer>
    </section>
    <section v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Hyper Burning and burning world"
             class="m-ignition-section section-forth">
      <article class="m-ignition-section__article">
        <header class="m-ignition-section__header">
          <h3 class="m-ignition-section__title">Hyper Burning and Burning World!</h3>
        </header>
        <main class="section-forth__main">
          <p class="m-ignition-section__text section-forth__main-text">
            The Burning World is back for your new Cygnus Knight characters, with a special bonus in the form of Hyper
            Burning! Gain two bonus levels every time you level-up with a new character all the way up to Lv. 250, and
            with Burning World's massive bonuses you'll be ready for MapleStory's latest adventures in no time!
          </p>
          <p class="m-ignition-section__text-arr">- Available Now -</p>
        </main>
        <footer></footer>
      </article>
    </section>
    <section v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Fireworks festival parade"
             class="m-ignition-section section-fifth">
      <article class="m-ignition-section__article">
        <header class="m-ignition-section__header">
          <h3 class="m-ignition-section__title">Fireworks Festival Parade!</h3>
        </header>
        <main class="section-fifth__main">
          <p class="m-ignition-section__text section-fifth__main-text">
            As the days grow shorter, the nights get longer, and that means more of a night sky to fill with fireworks!
            Send 2022 out with a bang with the Fireworks Festival Parade, collecting Ignition Coins and Flare Coins to
            redeem for special prizes, and enjoy special events and activities throughout November and December!
          </p>
          <p class="m-ignition-section__text-arr">- Available Now -</p>
        </main>
      </article>
    </section>
    <section v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Monster park extreme"
             class="m-ignition-section section-sixth">
      <article class="m-ignition-section__article">
        <header class="m-ignition-section__header section-sixth__header">
          <h3 class="m-ignition-section__title">Monster Park Extreme</h3>
        </header>
        <main class="section-sixth__main">
          <p class="m-ignition-section__text section-sixth__main-text">
            Monster Park is bringing Extreme difficulty back! Take on the new challenges in the Morass, Esfera, Sellas,
            and Moonbridge stages, hunt down the specified monsters, and take out the Extreme Bigfoot before the beast
            can escape for a truly <span class="bold">extreme</span> amount of EXP!
          </p>
          <p class="m-ignition-section__text-arr">- Available Now -</p>
        </main>
      </article>
    </section>
    <!--    <section v-observe-visibility="observeVisibilityDataLayerSettings" data-id="Coming December"-->
    <!--             class="m-ignition-section section-seventh">-->
    <!--      <article class="m-ignition-section__article">-->
    <!--        <header class="m-ignition-section__header section-seventh__header">-->
    <!--          <h3 class="m-ignition-section__title"> Coming December 14 - Ignition: Extreme</h3>-->
    <!--        </header>-->
    <!--        <main class="section-seventh__main">-->
    <!--          <p class="m-ignition-section__text section-seventh__main-text">-->
    <!--            Come back in December when the second part of 2022's winter updates arrives! Delve into Odium, a mysterious-->
    <!--            laboratory hidden away in the clouds, close 2022 out with a bang with a new set of Fireworks Festival Parade-->
    <!--            events, and more!-->
    <!--          </p>-->
    <!--        </main>-->
    <!--      </article>-->
    <!--    </section>-->
    <Footer
        color="#C8C1C1"
        hoverColor="#ff5e5b"
        backgroundColor="#1c080d"
        @go-to-main-click="clickTracking('Main Site')"
    />
    <Modal
        :show-modal="isShowModal"
        :additionalModalStyle="['popup']"
        :key-up-event="closeModal"
    >
      <template #header>
        <button @click="closeModal" class="popup__close-btn"/>
      </template>
      <template #body>
        <article class="popup__char">
          <header class="popup__char-title">
            <h3 class="popup__char-name">{{ charName }}</h3>
            <h4 class="popup__char-job">{{ charJob }} Job</h4>
          </header>
          <p class="popup__char-description">{{ charDescription }}</p>
        </article>
        <article :class="`popup__img-${charId}`">
          <img :src="require(`@/assets/images/microsites/ignition/characters/${charId}-transperent-bcg.png`)"
               alt="picture of character"/>
        </article>
      </template>
      <template #footer>
        <div class="popup__gif" :class="`popup__gif-${charId}`">
          <img :src="require(`@/assets/images/microsites/ignition/GIFs/${charId}-ability1.gif`)"
               alt="character`s ability"/>
          <h6 class="popup__gif-name">{{ abilityNames[0] }}</h6>
        </div>
        <div class="popup__gif" :class="`popup__gif-${charId}`">
          <img :src="require(`@/assets/images/microsites/ignition/GIFs/${charId}-ability2.gif`)"
               alt="character`s ability"/>
          <h6 class="popup__gif-name">{{ abilityNames[1] }}</h6>
        </div>
      </template>
    </Modal>
  </main>
</template>

<script>

import Responsive from "@/services/browser/Responsive";
import Footer from '@/components/microsites/Footer.vue'
import '@/assets/scss/microsites/ignition/_ignition.scss'
import Modal from "@/views/microsites/ignition/Modal";
import {CHARACTERS, SCREENSHOTS, PLACES} from "./constants"
import Util from '@/services/browser/Util';
import Cookie from "@/services/browser/Cookie";
import {defineComponent} from 'vue'
import {ObserveVisibility} from 'vue-observe-visibility'

export default defineComponent({
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  components: {
    Footer,
    Modal
  },
  data() {
    return {
      isShowHeader: false,
      isShowModal: false,
      characters: CHARACTERS,
      screenshots: SCREENSHOTS,
      places: PLACES,
      charId: '',
      charName: '',
      charJob: '',
      charDescription: '',
      abilityNames: [],
      isMobile: false
    }
  },
  mounted() {
    Responsive.init()
    Cookie.set("mapleignition", "true")
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    observeVisibilityDataLayerSettings() {
      return {
        callback: this.checkVisibility,
        intersection: {threshold: 0.3},
        throttle: 2000,
        once: true
      }
    },
    observeVisibilityNavSettings() {
      return {
        callback: this.updateNavVisibility,
        intersection: {threshold: 0.55},
      }
    }
  },
  methods: {
    handleResize(){
      this.isMobile = window.innerWidth <= 1024
    },
    openModal(characterNumber, char) {
      this.charId = characterNumber
      this.charName = char.name
      this.charJob = char.job
      this.charDescription = char.description
      this.abilityNames = char.abilityNames
      this.isShowModal = true

      this.clickTracking(`Cygnus Knight > ${char.name}`)
      document.body.classList.add("modal-active");
    },
    closeModal() {
      this.isShowModal = false
      document.body.classList.remove("modal-active");
    },
    onClickPlayFree() {
      Util.playFree();
      this.clickTracking('Play free')
    },
    onClickGoToPatch237() {
      this.clickTracking('v237 patch notes')
    },
    onClickGoToPatch238() {
      this.clickTracking('v238 patch notes')
    },
    clickTracking(element) {
      window.dataLayer.push({
        event: 'Transition Event',
        ec: 'Ignition Phase 3 Microsite',
        ea: 'click',
        el: element,
      })
    },
    viewTracking(element) {
      window.dataLayer.push({
        event: 'Element View', //this is a different event name
        ec: 'Ignition Phase 3 Microsite',
        ea: 'view',
        el: element,           // Section> Ignition warm-up event
        noninteraction: true,
      })
    },
    checkVisibility(isVisible, entry) {
      if (isVisible) {
        this.viewTracking(`Section > ${entry.target.dataset.id}`)
      }
    },
    updateNavVisibility(isVisible) {
      if (isVisible && this.isShowHeader) {
        this.isShowHeader = false
      } else if (!isVisible && !this.isShowHeader) {
        this.isShowHeader = true
      }
    },
  },
})
</script>